import {ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {Store} from '@ngrx/store';
import {PatronActions} from '@store/patron/patron.actions';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {MatTab, MatTabGroup, MatTabLabel} from '@angular/material/tabs';
import {InputFormFieldComponent} from '@aviary/forms/fields/input-form-field/input-form-field.component';
import {PasswordFormFieldComponent} from '@aviary/forms/fields/password-form-field/password-form-field.component';
import {CardLoginValue, EmailLoginValue} from '@store/patron/patron.types';
import {RegistrationActions} from '@store/registration/registration.actions';
import {buildFormGroup} from '@aviary/forms/form.helpers';
import {FALLBACK_CARD_LOGIN_VALUE, FALLBACK_EMAIL_LOGIN_VALUE} from '@store/patron/patron.fallback';
import {PatronValidators} from '@store/patron/patron.validators';
import {ActionButtonsComponent} from '@aviary/components/action-buttons/action-buttons.component';
import {TextButtonComponent} from '@aviary/buttons/text-button/text-button.component';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';
import {OutlinedButtonComponent} from '@aviary/buttons/outlined-button/outlined-button.component';

@Component({
  selector: 'px-login',
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatTabGroup, MatTab, MatTabLabel, InputFormFieldComponent, PasswordFormFieldComponent, ReactiveFormsModule, ActionButtonsComponent, TextButtonComponent,
    FilledButtonComponent, OutlinedButtonComponent
  ]
})
export class LoginComponent {
  private readonly store: Store = inject(Store);
  @Input() public emailForm: ExtendedFormGroup = buildFormGroup(FALLBACK_EMAIL_LOGIN_VALUE, inject(PatronValidators).emailLogin);
  @Input() public cardForm: ExtendedFormGroup = buildFormGroup(FALLBACK_CARD_LOGIN_VALUE, inject(PatronValidators).cardLogin);
  @Input() public dispatchLogins = true;
  @Output() public readonly forgotPasswordRequest: EventEmitter<never> = new EventEmitter<never>();
  @Output() public readonly loginSubmit: EventEmitter<EmailLoginValue | CardLoginValue> = new EventEmitter<EmailLoginValue | CardLoginValue>();

  forgotPassword(): void {
    this.forgotPasswordRequest.emit();
  }

  emailLogin(): void {
    this.loginSubmit.emit(this.emailForm.value);
    if (this.dispatchLogins) {
      this.store.dispatch(PatronActions.loginPatronWithEmail(this.emailForm.value.email, this.emailForm.value.password));
    }
  }

  cardLogin(): void {
    this.loginSubmit.emit(this.cardForm.value);
    if (this.dispatchLogins) {
      this.store.dispatch(PatronActions.loginPatronWithCard(this.cardForm.value.cardNumber, this.cardForm.value.pin));
    }
  }

  createAccount(): void {
    this.store.dispatch(RegistrationActions.showCreateAccount());
  }
}
